import type { Dict } from "./types";

export const common: Dict = {
  "nav.events": {
    tr: "Etkinlikler",
    en: "Events",
    de: "Events",
    fr: "Événements",
    ar: "الفعاليات",
    es: "Eventos",
  },
  "nav.admin": {
    tr: "Admin",
    en: "Admin",
    de: "Admin",
    fr: "Admin",
    ar: "المسؤول",
    es: "Administración",
  },
  "nav.account": {
    tr: "Hesabım",
    en: "My Account",
    de: "Mein Konto",
    fr: "Mon compte",
    ar: "حسابي",
    es: "Mi cuenta",
  },
  "nav.scanner": {
    tr: "Tarayıcı",
    en: "Scanner",
    de: "Scanner",
    fr: "Parcourir",
    ar: "المتصفح",
    es: "Escáner",
  },
  "nav.signout": {
    tr: "Çıkış",
    en: "Sign out",
    de: "Abmelden",
    fr: "Déconnexion",
    ar: "تسجيل الخروج",
    es: "Cerrar sesión",
  },
  "nav.login": {
    tr: "Giriş",
    en: "Log in",
    de: "Anmelden",
    fr: "Connexion",
    ar: "تسجيل الدخول",
    es: "Iniciar sesión",
  },
  "nav.signup": {
    tr: "Üye Ol",
    en: "Join",
    de: "Mitglied werden",
    fr: "S'inscrire",
    ar: "سجل الآن",
    es: "Unirse",
  },
  "common.loading": {
    tr: "Yükleniyor...",
    en: "Loading...",
    de: "Wird geladen...",
    fr: "Chargement...",
    ar: "جارٍ التحميل...",
    es: "Cargando...",
  },
  "common.save": {
    tr: "Kaydet",
    en: "Save",
    de: "Speichern",
    fr: "Enregistrer",
    ar: "حفظ",
    es: "Guardar",
  },
  "common.cancel": {
    tr: "İptal",
    en: "Cancel",
    de: "Abbrechen",
    fr: "Annuler",
    ar: "إلغاء",
    es: "Cancelar",
  },
  "common.close": {
    tr: "Kapat",
    en: "Close",
    de: "Schließen",
    fr: "Fermer",
    ar: "إغلاق",
    es: "Cerrar",
  },
  "common.back": {
    tr: "Geri",
    en: "Back",
    de: "Zurück",
    fr: "Retour",
    ar: "رجوع",
    es: "Atrás",
  },
  "common.send": {
    tr: "Gönder",
    en: "Send",
    de: "Senden",
    fr: "Envoyer",
    ar: "إرسال",
    es: "Enviar",
  },
  "common.confirm": {
    tr: "Onayla",
    en: "Confirm",
    de: "Bestätigen",
    fr: "Confirmer",
    ar: "تأكيد",
    es: "Confirmar",
  },
  "common.error": {
    tr: "Bir hata oluştu",
    en: "Something went wrong",
    de: "Es ist ein Fehler aufgetreten",
    fr: "Une erreur est survenue",
    ar: "حدث خطأ ما",
    es: "Algo salió mal",
  },
  "common.required": {
    tr: "Zorunlu alan",
    en: "Required field",
    de: "Pflichtfeld",
    fr: "Champ obligatoire",
    ar: "حقل إلزامي",
    es: "Campo obligatorio",
  },
  "common.language": {
    tr: "Dil",
    en: "Language",
    de: "Sprache",
    fr: "Langue",
    ar: "اللغة",
    es: "Idioma",
  },
  "common.home": {
    tr: "Ana sayfa",
    en: "Home",
    de: "Startseite",
    fr: "Accueil",
    ar: "الرئيسية",
    es: "Inicio",
  },
  "common.none": {
    tr: "Kayıt bulunamadı",
    en: "No records found",
    de: "Keine Einträge gefunden",
    fr: "Aucun enregistrement trouvé",
    ar: "لم يتم العثور على سجلات",
    es: "No se encontraron registros",
  },
  "common.person": {
    tr: "kişi",
    en: "people",
    de: "Personen",
    fr: "personne",
    ar: "شخص",
    es: "personas",
  },
  "common.piece": {
    tr: "adet",
    en: "pcs",
    de: "Stk.",
    fr: "pièce",
    ar: "قطعة",
    es: "uds.",
  },
  "footer.legal": {
    tr: "Yasal",
    en: "Legal",
    de: "Rechtliches",
    fr: "Légal",
    ar: "قانوني",
    es: "Legal",
  },
  "footer.rules": {
    tr: "Etkinlik Kuralları",
    en: "Event Rules",
    de: "Veranstaltungsregeln",
    fr: "Règles d'événement",
    ar: "قواعد الفعاليات",
    es: "Normas del evento",
  },
  "footer.kvkk": {
    tr: "KVKK",
    en: "Privacy (KVKK)",
    de: "Datenschutz (KVKK)",
    fr: "KVKK",
    ar: "KVKK",
    es: "Privacidad (KVKK)",
  },
  "footer.refund": {
    tr: "İade & İptal",
    en: "Refunds & Cancellation",
    de: "Rückgabe & Storno",
    fr: "Remboursement & Annulation",
    ar: "الاسترجاع والإلغاء",
    es: "Reembolsos y cancelaciones",
  },
  "footer.contact": {
    tr: "İletişim",
    en: "Contact",
    de: "Kontakt",
    fr: "Contact",
    ar: "اتصل بنا",
    es: "Contacto",
  },
  "footer.distance": {
    tr: "Mesafeli Satış Sözleşmesi",
    en: "Distance Sales Agreement",
    de: "Fernabsatzvertrag",
    fr: "Contrat de vente à distance",
    ar: "عقد البيع عن بعد",
    es: "Acuerdo de Venta a Distancia",
  },
  "footer.preinfo": {
    tr: "Ön Bilgilendirme",
    en: "Pre-Information Form",
    de: "Vorabinformation",
    fr: "Information préliminaire",
    ar: "المعلومات الأولية",
    es: "Formulario de Pre-Información",
  },
  "footer.rights": {
    tr: "Tüm hakları saklıdır.",
    en: "All rights reserved.",
    de: "Alle Rechte vorbehalten.",
    fr: "Tous droits réservés.",
    ar: "جميع الحقوق محفوظة.",
    es: "Todos los derechos reservados.",
  },
};
